export const buildUrl = (serlvet, action) => {
  return `${serlvet}?action=${action}`;
};
